module.exports = __webpack_public_path__ + "media/images/sp/page_common/icon/icon_stores_reserve_white-b6ae0ecf5a34a50e63c41535eaec7c9b.svg";